import {
	Card,
	Grid,
	Section,
	CaseStudyFilter,
	Lead,
} from '@tracsis/library/src';
import { getBusinessUnitFromID } from '@tracsis/library/lib/helpers';
import * as styles from './CaseStudyList.module.css';
import React from 'react';

const CaseStudyList = ({
	posts,
	title,
	subHeading,
	isGroup,
	showFilter,
	filterQuery,
	businessUnitList,
	more = false,
}: {
	posts: [];
	title?: string;
	subHeading?: string;
	isGroup?: boolean;
	showFilter?: boolean;
	filterQuery?: string;
	businessUnitList?: Array<string>;
	more?: boolean;
}) => {
	return (
		<>
			<Section>
				{title && (
					<Lead align="center">
						<h2>{title}</h2>
					</Lead>
				)}
				{isGroup && showFilter && (
					<CaseStudyFilter
						action="/case-studies/"
						filterQuery={filterQuery}
						businessUnitList={businessUnitList}
					/>
				)}

				{posts && posts.length > 0 ? (
					<Grid className={styles.gridMods}>
						{posts.map(({ node: post }: { node: any }, i: number) => {
							const story = JSON.parse(post.content);
							const { title, intro, image, business_unit } = story;
							const feature = more ? false : (i == 0 || i % 7 == 0);
							const buLabel = getBusinessUnitFromID(business_unit);
							const eyebrowText = buLabel == 'Tracsis US' ? 'Projects' : 'Case Study'

							const url = business_unit === 'e2605939-3e58-4311-841e-b4828550ab8b' ? // US UUID
								post.full_slug.replace(/case-studies\//g, `projects/`)
								: post.full_slug
							return (
								<Card
									key={i}
									thumbnail={feature ? `${image.filename}/m/640x540` : `${image.filename}/m/540x180`}
									alt={image.alt}
									to={isGroup ? `/${post.full_slug}` : `/${url}`}
									theme={'plain'}
									background={'lightBlue'}
									eyebrow={isGroup ? buLabel : eyebrowText}
									feature={feature}
									casestudy
								>
									<div className="rhythm">
										<h3>{title}</h3>

										{intro && <p>{intro}</p>}
									</div>
								</Card>
							);
						})}
					</Grid>
				) : (
					<p>There are no case studies found matching your search.</p>
				)}
			</Section >
		</>
	);
}

export default CaseStudyList;